import React from 'react'
import styled from 'styled-components'

import Hero from './Hero'
import Why from './Why'

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  & > * {
    flex-shrink: 0;
  }
`

class Landing extends React.Component {
  componentDidMount() {
    document.body.style.backgroundColor = 'white'
  }

  componentWillUnmount() {
    document.body.style.backgroundColor = ''
  }

  render() {
    return (
      <Wrapper>
        <Hero />
        <Why />
      </Wrapper>
    )
  }
}

export default Landing



// WEBPACK FOOTER //
// ./src/pages/Landing/index.js